// Interface to the external SDK that uses Komet. The interface is one-way, Komet can only send its
// own events to the SDK using `sendJIEvent`.

export function sendWebKitMessage(eventName, ...args) {
    try {
        const message = {
            event: eventName,
            arguments: args,
        };
        if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.KwizzAdJI
        ) {
            window.webkit.messageHandlers.KwizzAdJI.postMessage(message);
        }
    } catch (error) {
        console.log('Error while posting message', error);
    }
}

// Sends a given event name + args to the native app / SDK that integrates Komet.

function sendJIEvent(eventName, ...args) {
    if (typeof window.KwizzAdJI === 'object') {
        if (typeof window.KwizzAdJI[eventName] === 'function') {
            console.log(`Sending '${eventName}' event to Kwizzad JI API: ${JSON.stringify(args)}`);
            try {
                if (args && args.length > 0) {
                    KwizzAdJI[eventName](...args); // eslint-disable-line no-undef
                } else {
                    KwizzAdJI[eventName](); // eslint-disable-line no-undef
                }
            } catch (error) {
                console.log(`Could not send '${eventName}' event to JI API: ${String(error)}`);
            }
        } else {
            console.log(`Ignored '${eventName}' event. JI API is initialized, but does not support this event.`);
        }
    } else {
        console.log(`Ignored '${eventName}' event, JI API not available.`);
    }

    sendWebKitMessage(eventName, ...args);
}

export default sendJIEvent;



// WEBPACK FOOTER //
// ./src/lib/kwizzad-ji.jsx